enum Currency {
  SEK = "SEK",
  EUR = "EUR",
}

export { Currency };
